<template>
  <div class="container pb-4">

    <div class="row pb-3">
        <div class="col">
          <h5>{{`${user.name} ${user.surname}`}}</h5>
        </div>
        <div class="col text-right">
          <balance-component :balance="user.balance" :user="user" @balance-updated="balanceUpdated"></balance-component>
        </div>
    </div>

          <b-card no-body>
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Profile" title-link-class="darklink">
          <b-card-text>
            <buyer-profile :user="user" :headless="true"></buyer-profile>
            </b-card-text>
        </b-tab>
        <b-tab title="Products" title-link-class="darklink">
          <b-card-text>
            <div class="py-3 text-center">Products go here</div>
          </b-card-text>
        </b-tab>
        <b-tab title="Transactions" title-link-class="darklink">
          <b-card-text>
            <transactions :user="user" :headless="true" ref="Transactions"></transactions>
          </b-card-text>
        </b-tab>
        <b-tab title="Banking" title-link-class="darklink">
          <b-card-text>
            <user-banking :user="user" :headless="true"></user-banking>
          </b-card-text>
        </b-tab>
  
      </b-tabs>
    </b-card>

      </div>

</template>

<script>
export default {
  props: ['user'],

  data() {
    return {
      tabIndex: 0,
    };
  },

  methods: {
    balanceUpdated() {
      this.$refs.Transactions.getTransactions();
    },
  },

};
</script> 